"use client";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { useRef, useState } from "react";
import { ArrowRightCircleIcon, ArrowLeftCircleIcon } from "@heroicons/react/20/solid";
import Image from "next/image";

const QuoteImageSlider = () => {
  const [loaded, setLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    mode: "free-snap",
    initial: 0,

    slideChanged(s) {
      setCurrentSlide(s.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  // load slider after all images are loaded -- fix image layout issue (show more than 1 image per view)
  const imagesLoaded = useRef(0);
  const handleImageLoad = () => {
    imagesLoaded.current += 1;
    if (imagesLoaded.current === slides.length && slider) {
      slider.current?.update();
    }
  };

  const slides = [
    // {
    //   src: "/images/about-us/career/Pic4.png",
    //   alt: "Slide 1",
    //   quote:
    //     "“The team have given the up most support, trust, and the room to be able to grow. I am loving my role and the team I am surrounded with.”",
    //   author: "Alex L.",
    //   title: "Support Worker Team Lead - VIC",
    // },
    {
      src: "/images/about-us/career/Pic6.png",
      alt: "Slide 1",
      quote:
        "“Having a company regularly check in makes a real difference. I genuinely appreciate the care, understanding, and ongoing support Incluso Services offer.”",
      author: "Suman K.",
      title: "Support Worker VIC",
    },
    {
      src: "/images/about-us/career/Pic5.png",
      alt: "Slide 2",
      quote:
        "“Incluso has a really strong culture that is centered on the participant. This has enabled me to develop my professional offering.”",
      author: "Graham E.",
      title: "Support Coordinator",
    },
  ];

  return (
    <div className="slider-wrapper relative flex flex-col gap-4 md:flex-row md:gap-6 xl:gap-8">
      {/* texts */}
      <div className="order-last flex flex-col gap-5 md:w-[40%] xl:w-1/3">
        <p className="text-desk-resp-xl leading-tight xl:mt-4">{slides[currentSlide]?.quote}</p>
        <p className="text-resp-lg leading-6">
          <span className="font-bold">{slides[currentSlide]?.author}</span>
          <span className="block">{slides[currentSlide]?.title}</span>
        </p>
      </div>

      {/* slider */}
      <div className="md:w-[60%] xl:w-[74%]">
        <div ref={sliderRef} className="keen-slider">
          {slides.map((slide, i) => (
            <div key={i} className={`keen-slider__slide number-slide${i + 1}`}>
              <Image
                src={slide.src}
                alt={slide.alt}
                width={500}
                height={500}
                className="h-auto w-full object-cover"
                onLoad={handleImageLoad}
              />
            </div>
          ))}
        </div>

        {/* arrow control */}
        {loaded && slider.current && (
          <div className="mb-5 mt-1">
            <ArrowRightCircleIcon
              onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => slider.current?.next() || e.stopPropagation()}
              className={`absolute size-7 cursor-pointer lg:size-9 ${
                currentSlide === slider.current.track.details.slides.length - 1 ? "pointer-events-none fill-green/0" : "fill-green"
              }`}
            />
            <ArrowLeftCircleIcon
              onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => slider.current?.prev() || e.stopPropagation()}
              className={`absolute size-7 cursor-pointer lg:size-9 ${
                currentSlide === 0 ? "pointer-events-none fill-green/0" : "fill-green"
              } `}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default QuoteImageSlider;
